import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { loadClientConfig } from './lib/api';
import './lib/settings';
import './styles/global.css';
import './styles/meeting.css';

// Learn the address used for invitation links as early as possible (best effort).
void loadClientConfig().catch(() => undefined);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
